import React from "react";
import { useParams } from "react-router-dom";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

const ReportViewer = () => {
  const { filename } = useParams(); 
  const reportUrl = `${backendUrl}/${filename}`; 

  return (
    <iframe
      title="Automation Report"
      src={reportUrl}
      style={{ width: "100%", height: "100vh", border: "none" }}
    />
  );
};

export default ReportViewer;
